import axios from 'axios'
import {
    Message,
    Loading
} from 'element-ui';
import router from '@/router'
axios.defaults.withCredentials = false; //设置cross跨域 并设置访问权限 允许跨域携带cookie信息
// var domain = process.env.NODE_ENV === 'production' ? '' : 'http://traceable.mall.yunyiit.com'
// 开发环境使用代理，生产环境使用实际域名
var domain = process.env.NODE_ENV === 'production' ? '' : 'http://liangc.yunyiit.com'
// var domain = process.env.NODE_ENV === 'production' ? '' : '/api'
let loadingInstance;
export default {
    domain: domain,

    post(apiUrl, data, loading = true) {
        data = JSON.stringify(data);
        return new Promise((resolve, reject) => {
            if (loading) {
                loadingInstance = Loading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                    customClass: 'myLoading',
                });
            }
            var url = this.domain + apiUrl;
            axios.post(url, data).then(res => {
                if (res.data.code == '0000') {
                    resolve(res.data.data);
                } else if (res.data.code == '2001') {
                    if (router.currentRoute.name != '/') {
                        //未登录或登录超时
                        router.push('/')
                    }
                } else {
                    Message.closeAll();
                    Message.error(res.data.msg);
                }
                if(loading){
                    loadingInstance.close();
                }
            }).catch(err => {
                if(loading){
                    loadingInstance.close();
                }
                console.log(err);
                reject("ajax请求失败", err);
            });
        });
    }
}
